import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toArray from "@babel/runtime/helpers/toArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useCallback, useRef, useState } from 'react';
import { Button, FormControl, FormHelperText, MenuItem, Select, TextField, Typography, IconButton } from '@mui/material';
import { Icon, SimpleModal, toast } from '@livable/saas-react-components';
import { observer, useLocalObservable } from 'mobx-react-lite';
import Papa from 'papaparse';
import { useStore } from 'src/stores';
import { MapUnitNamesSection } from '../MapUnitNamesSection';
const CELL_BORDER = '1px solid #e0e0e0';
export const COLUMN_FIELD_MAP = [{
  label: 'Start read date',
  field: 'startReadDateColumn'
}, {
  label: 'End read date',
  field: 'endReadDateColumn'
}, {
  label: 'Start read',
  field: 'startReadColumn'
}, {
  label: 'End read',
  field: 'endReadColumn'
}, {
  label: 'Usage',
  field: 'usageColumn'
}, {
  label: 'Meter ID',
  field: 'meterIdColumn'
}, {
  label: 'Unit name',
  field: 'unitNameColumn'
}, {
  label: 'Unit of measure',
  field: 'uomColumn'
}, {
  label: 'Provider phone',
  field: 'providerPhoneColumn',
  optional: true
}, {
  label: 'Billing agent disclosure',
  field: 'billingAgentDisclosureColumn',
  optional: true
}, {
  label: 'Leak service contact',
  field: 'leakServiceContactColumn',
  optional: true
}];
const normalizeColumnName = value => (value || '').trim().toLowerCase();
const toMatchKey = value => (value || '').toLowerCase().replace(/(?:[\0-\/:-@\[-`\{-\xA9\xAB-\xB1\xB4\xB6-\xB8\xBB\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u036F\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482-\u0489\u0530\u0557\u0558\u055A-\u055F\u0589-\u05CF\u05EB-\u05EE\u05F3-\u061F\u064B-\u065F\u066A-\u066D\u0670\u06D4\u06D6-\u06E4\u06E7-\u06ED\u06FD\u06FE\u0700-\u070F\u0711\u0730-\u074C\u07A6-\u07B0\u07B2-\u07BF\u07EB-\u07F3\u07F6-\u07F9\u07FB-\u07FF\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u083F\u0859-\u085F\u086B-\u086F\u0888\u0890-\u089F\u08CA-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962-\u0965\u0970\u0981-\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA-\u09BC\u09BE-\u09CD\u09CF-\u09DB\u09DE\u09E2-\u09E5\u09F2\u09F3\u09FA\u09FB\u09FD-\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A-\u0A58\u0A5D\u0A5F-\u0A65\u0A70\u0A71\u0A75-\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA-\u0ABC\u0ABE-\u0ACF\u0AD1-\u0ADF\u0AE2-\u0AE5\u0AF0-\u0AF8\u0AFA-\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A-\u0B3C\u0B3E-\u0B5B\u0B5E\u0B62-\u0B65\u0B70\u0B78-\u0B82\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BCF\u0BD1-\u0BE5\u0BF3-\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C3E-\u0C57\u0C5B\u0C5E\u0C5F\u0C62-\u0C65\u0C70-\u0C77\u0C7F\u0C81-\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA-\u0CBC\u0CBE-\u0CDB\u0CDF\u0CE2-\u0CE5\u0CF0\u0CF3-\u0D03\u0D0D\u0D11\u0D3B\u0D3C\u0D3E-\u0D4D\u0D4F-\u0D53\u0D57\u0D62-\u0D65\u0D79\u0D80-\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DE5\u0DF0-\u0E00\u0E31\u0E34-\u0E3F\u0E47-\u0E4F\u0E5A-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EB1\u0EB4-\u0EBC\u0EBE\u0EBF\u0EC5\u0EC7-\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F01-\u0F1F\u0F34-\u0F3F\u0F48\u0F6D-\u0F87\u0F8D-\u0FFF\u102B-\u103E\u104A-\u104F\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B-\u1368\u137D-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u1680\u169B-\u169F\u16EB-\u16ED\u16F9-\u16FF\u1712-\u171E\u1732-\u173F\u1752-\u175F\u176D\u1771-\u177F\u17B4-\u17D6\u17D8-\u17DB\u17DD-\u17DF\u17EA-\u17EF\u17FA-\u180F\u181A-\u181F\u1879-\u187F\u1885\u1886\u18A9\u18AB-\u18AF\u18F6-\u18FF\u191F-\u1945\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19FF\u1A17-\u1A1F\u1A55-\u1A7F\u1A8A-\u1A8F\u1A9A-\u1AA6\u1AA8-\u1B04\u1B34-\u1B44\u1B4D-\u1B4F\u1B5A-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BFF\u1C24-\u1C3F\u1C4A-\u1C4C\u1C7E\u1C7F\u1C8B-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1CFB-\u1CFF\u1DC0-\u1DFF\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u206F\u2072\u2073\u207A-\u207E\u208A-\u208F\u209D-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A-\u245F\u249C-\u24E9\u2500-\u2775\u2794-\u2BFF\u2CE5-\u2CEA\u2CEF-\u2CF1\u2CF4-\u2CFC\u2CFE\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7F\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF-\u2E2E\u2E30-\u3004\u3008-\u3020\u302A-\u3030\u3036\u3037\u303D-\u3040\u3097-\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u3191\u3196-\u319F\u31C0-\u31EF\u3200-\u321F\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA62C-\uA63F\uA66F-\uA67E\uA69E\uA69F\uA6F0-\uA716\uA720\uA721\uA789\uA78A\uA7DD-\uA7F0\uA802\uA806\uA80B\uA823-\uA82F\uA836-\uA83F\uA874-\uA881\uA8B4-\uA8CF\uA8DA-\uA8F1\uA8F8-\uA8FA\uA8FC\uA8FF\uA926-\uA92F\uA947-\uA95F\uA97D-\uA983\uA9B3-\uA9CE\uA9DA-\uA9DF\uA9E5\uA9FF\uAA29-\uAA3F\uAA43\uAA4C-\uAA4F\uAA5A-\uAA5F\uAA77-\uAA79\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAC3-\uAADA\uAADE\uAADF\uAAEB-\uAAF1\uAAF5-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABE3-\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB1E\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFE6F\uFE75\uFEFD-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDD06\uDD34-\uDD3F\uDD79-\uDD89\uDD8C-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEE0\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF76-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6F\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDBF\uDDF4-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC57\uDC77\uDC78\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1F\uDD3A-\uDD3F\uDD5A-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE01-\uDE0F\uDE14\uDE18\uDE36-\uDE3F\uDE49-\uDE5F\uDE7F\uDEA0-\uDEBF\uDEC8\uDEE5-\uDEEA\uDEF0-\uDEFF\uDF36-\uDF3F\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD24-\uDD2F\uDD3A-\uDD3F\uDD66-\uDD6E\uDD86-\uDE5F\uDE7F\uDEAA-\uDEAF\uDEB2-\uDEC1\uDEC8-\uDEFF\uDF28-\uDF2F\uDF46-\uDF50\uDF55-\uDF6F\uDF82-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC00-\uDC02\uDC38-\uDC51\uDC70\uDC73\uDC74\uDC76-\uDC82\uDCB0-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDD02\uDD27-\uDD35\uDD40-\uDD43\uDD45\uDD46\uDD48-\uDD4F\uDD73-\uDD75\uDD77-\uDD82\uDDB3-\uDDC0\uDDC5-\uDDCF\uDDDB\uDDDD-\uDDE0\uDDF5-\uDDFF\uDE12\uDE2C-\uDE3E\uDE41-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEDF-\uDEEF\uDEFA-\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A-\uDF3C\uDF3E-\uDF4F\uDF51-\uDF5C\uDF62-\uDF7F\uDF8A\uDF8C\uDF8D\uDF8F\uDFB6\uDFB8-\uDFD0\uDFD2\uDFD4-\uDFFF]|\uD805[\uDC35-\uDC46\uDC4B-\uDC4F\uDC5A-\uDC5E\uDC62-\uDC7F\uDCB0-\uDCC3\uDCC6\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDAF-\uDDD7\uDDDC-\uDDFF\uDE30-\uDE43\uDE45-\uDE4F\uDE5A-\uDE7F\uDEAB-\uDEB7\uDEB9-\uDEBF\uDECA-\uDECF\uDEE4-\uDEFF\uDF1B-\uDF2F\uDF3C-\uDF3F\uDF47-\uDFFF]|\uD806[\uDC2C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD30-\uDD3E\uDD40\uDD42-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD1-\uDDE0\uDDE2\uDDE4-\uDDFF\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE4F\uDE51-\uDE5B\uDE8A-\uDE9C\uDE9E-\uDEAF\uDEF9-\uDFBF\uDFE1-\uDFEF\uDFFA-\uDFFF]|\uD807[\uDC09\uDC2F-\uDC3F\uDC41-\uDC4F\uDC6D-\uDC71\uDC90-\uDCFF\uDD07\uDD0A\uDD31-\uDD45\uDD47-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8A-\uDD97\uDD99-\uDD9F\uDDAA-\uDDAF\uDDDC-\uDDDF\uDDEA-\uDEDF\uDEF3-\uDF01\uDF03\uDF11\uDF34-\uDF4F\uDF5A-\uDFAF\uDFB1-\uDFBF\uDFD5-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD812-\uD817\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD836\uD83D\uD83F\uD87C\uD87D\uD87F\uD88E-\uDBFF][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF1-\uDFFF]|\uD80D[\uDC30-\uDC40\uDC47-\uDC5F]|\uD810[\uDFFB-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD818[\uDC00-\uDCFF\uDD1E-\uDD2F\uDD3A-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6F\uDEBF\uDECA-\uDECF\uDEEE-\uDEFF\uDF30-\uDF3F\uDF44-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDD3F\uDD6D-\uDD6F\uDD7A-\uDE3F\uDE97-\uDE9F\uDEB9\uDEBA\uDED4-\uDEFF\uDF4B-\uDF4F\uDF51-\uDF92\uDFA0-\uDFDF\uDFE2\uDFE4-\uDFF1\uDFF7-\uDFFF]|\uD823[\uDCD6-\uDCFE\uDD1F-\uDD7F\uDDF3-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD31\uDD33-\uDD4F\uDD53\uDD54\uDD56-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDFFF]|\uD833[\uDC00-\uDCEF\uDCFA-\uDFFF]|\uD834[\uDC00-\uDEBF\uDED4-\uDEDF\uDEF4-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC\uDFCD]|\uD837[\uDC00-\uDEFF\uDF1F-\uDF24\uDF2B-\uDFFF]|\uD838[\uDC00-\uDC2F\uDC6E-\uDCFF\uDD2D-\uDD36\uDD3E\uDD3F\uDD4A-\uDD4D\uDD4F-\uDE8F\uDEAE-\uDEBF\uDEEC-\uDEEF\uDEFA-\uDFFF]|\uD839[\uDC00-\uDCCF\uDCEC-\uDCEF\uDCFA-\uDDCF\uDDEE\uDDEF\uDDFB-\uDEBF\uDEDF\uDEE3\uDEE6\uDEEE\uDEEF\uDEF5-\uDEFD\uDF00-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD0-\uDCFF\uDD44-\uDD4A\uDD4C-\uDD4F\uDD5A-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCAC\uDCB0\uDCB5-\uDD00\uDD2E\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDFFF]|\uD83E[\uDC00-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEAE\uDEAF]|\uD87A[\uDFE1-\uDFEF]|\uD87B[\uDE5E-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDF4F]|\uD88D[\uDC7A-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, '');
const groupByMatchKey = (items, getName) => items.reduce((groups, item) => {
  var _groups$get;
  const key = toMatchKey(getName(item));
  groups.set(key, [...((_groups$get = groups.get(key)) !== null && _groups$get !== void 0 ? _groups$get : []), item]);
  return groups;
}, new Map());
export const matchColumnsToHeaders = (fields, headers, current) => {
  const fieldGroups = groupByMatchKey(fields, f => f.label);
  const headerGroups = groupByMatchKey(headers, h => h);
  const usedHeaders = new Set(Object.values(current).filter(Boolean).map(normalizeColumnName));
  return fields.reduce((matches, _ref) => {
    var _headerGroups$get;
    let label = _ref.label,
      field = _ref.field;
    const key = toMatchKey(label);
    const _ref2 = (_headerGroups$get = headerGroups.get(key)) !== null && _headerGroups$get !== void 0 ? _headerGroups$get : [],
      _ref3 = _toArray(_ref2),
      header = _ref3[0],
      extra = _arrayLikeToArray(_ref3).slice(1);
    const isUnique = fieldGroups.get(key).length === 1 && header !== undefined && !extra.length;
    if (isUnique && !current[field] && !usedHeaders.has(normalizeColumnName(header))) {
      matches[field] = header;
    }
    return matches;
  }, {});
};
const findDuplicateColumns = columnMappings => COLUMN_FIELD_MAP.reduce((acc, _ref4) => {
  let field = _ref4.field;
  const name = normalizeColumnName(columnMappings[field]);
  if (!name) return acc;
  const other = COLUMN_FIELD_MAP.find(f => f.field !== field && normalizeColumnName(columnMappings[f.field]) === name);
  return other ? _objectSpread(_objectSpread({}, acc), {}, {
    [field]: "Already used for ".concat(other.label)
  }) : acc;
}, {});

// Module-level observer — re-renders only when validity/inProgress changes
const CreateSaveButton = observer(_ref5 => {
  let validityStore = _ref5.validityStore,
    onClick = _ref5.onClick;
  const store = useStore();
  return /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: onClick,
    disabled: store.allocations.postSubmeterBillingCsvMapAsync.inProgress || !validityStore.isFormValid || !validityStore.isUnitValid
  }, "Save mapping");
});
const EditSaveButton = observer(_ref6 => {
  let validityStore = _ref6.validityStore,
    onClick = _ref6.onClick;
  const store = useStore();
  return /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: onClick,
    disabled: store.allocations.putSubmeterBillingCsvMapAsync.inProgress || !validityStore.isFormValid || !validityStore.isUnitValid
  }, "Save mapping");
});

// Defined at module level — never remounts due to parent re-renders
const MapColumnsFormContent = _ref7 => {
  let dataRef = _ref7.dataRef,
    onValidChange = _ref7.onValidChange,
    initialValues = _ref7.initialValues;
  const _useState = useState((initialValues === null || initialValues === void 0 ? void 0 : initialValues.name) || ''),
    _useState2 = _slicedToArray(_useState, 2),
    mappingName = _useState2[0],
    setMappingName = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    csvFile = _useState4[0],
    setCsvFile = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    csvHeaders = _useState6[0],
    setCsvHeaders = _useState6[1];
  const _useState7 = useState(() => COLUMN_FIELD_MAP.reduce((acc, _ref8) => {
      let field = _ref8.field;
      return _objectSpread(_objectSpread({}, acc), {}, {
        [field]: (initialValues === null || initialValues === void 0 ? void 0 : initialValues[field]) || ''
      });
    }, {})),
    _useState8 = _slicedToArray(_useState7, 2),
    columnMappings = _useState8[0],
    setColumnMappings = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isDragging = _useState0[0],
    setIsDragging = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showErrors = _useState10[0],
    setShowErrors = _useState10[1];
  const _useState11 = useState(() => COLUMN_FIELD_MAP.some(_ref9 => {
      let field = _ref9.field;
      return !!(initialValues !== null && initialValues !== void 0 && initialValues[field]);
    })),
    _useState12 = _slicedToArray(_useState11, 1),
    hasSavedColumns = _useState12[0];
  const activeFile = useRef(null);
  const fileInputRef = useRef(null);
  const isNameValid = !!mappingName.trim();
  const duplicateColumns = findDuplicateColumns(columnMappings);
  const isColumnsValid = COLUMN_FIELD_MAP.filter(f => !f.optional).every(_ref0 => {
    let field = _ref0.field;
    return !!columnMappings[field];
  }) && !Object.keys(duplicateColumns).length;
  const isValid = isNameValid && isColumnsValid;
  onValidChange === null || onValidChange === void 0 || onValidChange(isValid);
  const readHeaders = async file => {
    try {
      var _rows$;
      const text = await file.text();
      const rows = Papa.parse(text, {
        delimiter: ',',
        preview: 20
      }).data.filter(row => {
        var _row$;
        return row.length > 1 || ((_row$ = row[0]) === null || _row$ === void 0 ? void 0 : _row$.trim());
      });
      return ((_rows$ = rows[0]) !== null && _rows$ !== void 0 ? _rows$ : []).map(h => h.trim()).filter(Boolean);
    } catch (_unused) {
      return [];
    }
  };
  const loadFile = async file => {
    activeFile.current = file;
    setCsvFile(file);
    setCsvHeaders([]);
    if (!hasSavedColumns) setColumnMappings({});
    const headers = await readHeaders(file);
    if (activeFile.current !== file) return;
    setCsvHeaders(headers);
    setColumnMappings(prev => _objectSpread(_objectSpread({}, prev), matchColumnsToHeaders(COLUMN_FIELD_MAP, headers, prev)));
  };
  const handleFileChange = async e => {
    var _e$target$files;
    const file = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];
    if (file) await loadFile(file);
  };
  const handleDragOver = e => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => setIsDragging(false);
  const handleDrop = async e => {
    var _e$dataTransfer$files;
    e.preventDefault();
    setIsDragging(false);
    const file = (_e$dataTransfer$files = e.dataTransfer.files) === null || _e$dataTransfer$files === void 0 ? void 0 : _e$dataTransfer$files[0];
    if (file) await loadFile(file);
  };
  const handleRemoveFile = () => {
    activeFile.current = null;
    setCsvFile(null);
    setCsvHeaders([]);
    if (!hasSavedColumns) setColumnMappings({});
    if (fileInputRef.current) fileInputRef.current.value = '';
  };
  const handleColumnPick = (field, value) => setColumnMappings(prev => _objectSpread(_objectSpread({}, prev), {}, {
    [field]: value
  }));
  if (dataRef) {
    dataRef.current = _objectSpread(_objectSpread({
      name: mappingName
    }, COLUMN_FIELD_MAP.reduce((acc, _ref1) => {
      let field = _ref1.field;
      return _objectSpread(_objectSpread({}, acc), {}, {
        [field]: columnMappings[field] || ''
      });
    }, {})), {}, {
      validate: () => {
        setShowErrors(true);
        return isValid;
      }
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "Mapping name",
    placeholder: "Mapping name",
    value: mappingName,
    onChange: e => setMappingName(e.target.value),
    variant: "outlined",
    error: showErrors && !isNameValid,
    helperText: showErrors && !isNameValid ? 'Required' : undefined
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      border: "1px dashed ".concat(isDragging ? '#1976d2' : '#b8c4ce'),
      borderRadius: 4,
      padding: csvFile ? 12 : 48,
      cursor: !csvFile ? 'pointer' : 'default',
      marginBottom: 24,
      backgroundColor: isDragging ? 'rgba(25,118,210,0.04)' : undefined
    },
    onClick: () => {
      var _fileInputRef$current;
      return !csvFile && ((_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click());
    },
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop
  }, !csvFile ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    align: "center",
    color: "light"
  }, "Upload a CSV to auto-detect column names (optional)") : /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-text"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      flex: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontWeight: 600
    }
  }, csvFile.name), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    size: "small",
    style: {
      minWidth: 0
    },
    onClick: e => {
      e.stopPropagation();
      handleRemoveFile();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }))), /*#__PURE__*/React.createElement("input", {
    ref: fileInputRef,
    type: "file",
    accept: ".csv",
    hidden: true,
    onChange: handleFileChange
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 600,
      marginBottom: 4
    }
  }, "Map column names"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "light",
    style: {
      marginBottom: 16
    }
  }, "Map Livable field names to column names in your CSV"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      borderBottom: CELL_BORDER,
      paddingBottom: 8
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      padding: '0 12px 0 0',
      borderRight: CELL_BORDER
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, "Livable field")), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      padding: '0 0 0 12px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, "CSV column name"))), COLUMN_FIELD_MAP.map((_ref10, idx) => {
    let label = _ref10.label,
      field = _ref10.field,
      optional = _ref10.optional;
    return /*#__PURE__*/React.createElement("div", {
      key: field,
      style: {
        display: 'flex',
        alignItems: 'center',
        borderBottom: idx < COLUMN_FIELD_MAP.length - 1 ? CELL_BORDER : undefined
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        padding: '8px 12px 8px 0',
        borderRight: CELL_BORDER
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 600
      }
    }, label, optional && /*#__PURE__*/React.createElement(Typography, {
      component: "span",
      variant: "body2",
      color: "light",
      style: {
        fontWeight: 400,
        marginLeft: 4
      }
    }, "(optional)"))), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        padding: '4px 0 4px 12px'
      }
    }, csvHeaders.length > 0 ? /*#__PURE__*/React.createElement(FormControl, {
      size: "small",
      fullWidth: true,
      error: !!duplicateColumns[field] || showErrors && !optional && !columnMappings[field]
    }, /*#__PURE__*/React.createElement(Select, {
      value: columnMappings[field] || '',
      onChange: e => handleColumnPick(field, e.target.value),
      displayEmpty: true,
      SelectDisplayProps: duplicateColumns[field] ? {
        'aria-invalid': true,
        'aria-describedby': "column-".concat(field, "-helper-text")
      } : undefined,
      renderValue: val => val ? val : /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#9e9e9e'
        }
      }, "Select column")
    }, optional && /*#__PURE__*/React.createElement(MenuItem, {
      value: ""
    }, "None"), [...new Set([...csvHeaders, initialValues === null || initialValues === void 0 ? void 0 : initialValues[field], columnMappings[field]].filter(Boolean))].filter(h => !Object.entries(columnMappings).some(_ref11 => {
      let _ref12 = _slicedToArray(_ref11, 2),
        f = _ref12[0],
        v = _ref12[1];
      return f !== field && v === h;
    })).map(h => /*#__PURE__*/React.createElement(MenuItem, {
      key: h,
      value: h
    }, h))), (duplicateColumns[field] || showErrors && !optional && !columnMappings[field]) && /*#__PURE__*/React.createElement(FormHelperText, {
      id: "column-".concat(field, "-helper-text")
    }, duplicateColumns[field] || 'Required')) : /*#__PURE__*/React.createElement(TextField, {
      size: "small",
      fullWidth: true,
      placeholder: "Column name",
      value: columnMappings[field] || '',
      onChange: e => setColumnMappings(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [field]: e.target.value
      })),
      error: !!duplicateColumns[field] || showErrors && !optional && !columnMappings[field],
      helperText: duplicateColumns[field] || (showErrors && !optional && !columnMappings[field] ? 'Required' : undefined)
    })));
  }));
};
const MapColumnsViewContent = _ref13 => {
  var _mapping$unitMappings;
  let mapping = _ref13.mapping;
  const unitEntries = Array.isArray(mapping.unitMappings) ? mapping.unitMappings.map(_ref14 => {
    let unitId = _ref14.unitId,
      identifiers = _ref14.identifiers;
    return [unitId, (identifiers === null || identifiers === void 0 ? void 0 : identifiers[0]) || ''];
  }) : Object.entries((_mapping$unitMappings = mapping.unitMappings) !== null && _mapping$unitMappings !== void 0 ? _mapping$unitMappings : {});
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 600,
      marginBottom: 4
    }
  }, "Map column names"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "light",
    style: {
      marginBottom: 16
    }
  }, "Livable field names mapped to your CSV column names"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      borderBottom: CELL_BORDER,
      paddingBottom: 8
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      padding: '0 12px 0 0',
      borderRight: CELL_BORDER
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, "Livable field")), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      padding: '0 0 0 12px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, "CSV column name"))), COLUMN_FIELD_MAP.map((_ref15, idx) => {
    var _mapping$columnMappin;
    let label = _ref15.label,
      field = _ref15.field;
    return /*#__PURE__*/React.createElement("div", {
      key: field,
      style: {
        display: 'flex',
        alignItems: 'center',
        borderBottom: idx < COLUMN_FIELD_MAP.length - 1 ? CELL_BORDER : undefined
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        padding: '8px 12px 8px 0',
        borderRight: CELL_BORDER
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 600
      }
    }, label)), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        padding: '8px 0 8px 12px'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_mapping$columnMappin = mapping.columnMappings) === null || _mapping$columnMappin === void 0 ? void 0 : _mapping$columnMappin[field]) || mapping[field] || '—')));
  }), unitEntries.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 24
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 600,
      marginBottom: 4
    }
  }, "Map unit names"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "light",
    style: {
      marginBottom: 16
    }
  }, "Livable unit names mapped to your CSV unit names"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      borderBottom: CELL_BORDER,
      paddingBottom: 8
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      padding: '0 12px 0 0',
      borderRight: CELL_BORDER
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, "Livable unit name")), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      padding: '0 0 0 12px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, "CSV unit name"))), unitEntries.map((_ref16, idx) => {
    let _ref17 = _slicedToArray(_ref16, 2),
      livableName = _ref17[0],
      csvName = _ref17[1];
    return /*#__PURE__*/React.createElement("div", {
      key: livableName,
      style: {
        display: 'flex',
        alignItems: 'center',
        borderBottom: idx < unitEntries.length - 1 ? CELL_BORDER : undefined
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        padding: '8px 12px 8px 0',
        borderRight: CELL_BORDER
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 600
      }
    }, livableName)), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        padding: '8px 0 8px 12px'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, csvName || '—')));
  })));
};
export const MapColumnsViewModal = _ref18 => {
  let mapping = _ref18.mapping;
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isOpen = _useState14[0],
    setIsOpen = _useState14[1];
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      style: {
        fontWeight: 600,
        cursor: 'pointer',
        textDecoration: 'underline'
      },
      onClick: () => setIsOpen(true)
    }, mapping.name || 'Mapping'),
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, mapping.name || 'Mapping'),
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: () => setIsOpen(false)
    }, "Close"),
    isOpen: isOpen,
    handleOpen: () => setIsOpen(true),
    handleClose: () => setIsOpen(false)
  }, /*#__PURE__*/React.createElement(MapColumnsViewContent, {
    mapping: mapping
  }));
};
export const MapColumnsModal = _ref19 => {
  let onSave = _ref19.onSave,
    propertyId = _ref19.propertyId,
    utilityId = _ref19.utilityId,
    propertyUtilityId = _ref19.propertyUtilityId;
  const store = useStore();
  const _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isOpen = _useState16[0],
    setIsOpen = _useState16[1];
  const _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    formKey = _useState18[0],
    setFormKey = _useState18[1];
  const dataRef = useRef({});
  const unitDataRef = useRef({});
  const validityStore = useLocalObservable(() => ({
    isFormValid: false,
    isUnitValid: true
  }));
  const handleFormValidChange = useCallback(valid => {
    validityStore.isFormValid = valid;
  }, [validityStore]);
  const handleUnitValidChange = useCallback(valid => {
    validityStore.isUnitValid = valid;
  }, [validityStore]);
  const handleOpen = () => {
    validityStore.isFormValid = false;
    validityStore.isUnitValid = true;
    setFormKey(k => k + 1);
    setIsOpen(true);
  };
  const handleClose = () => setIsOpen(false);
  const handleSave = async () => {
    var _dataRef$current$vali, _dataRef$current$vali2, _dataRef$current, _unitDataRef$current$, _unitDataRef$current$2, _unitDataRef$current, _store$homeDashboardS, _store$homeDashboardS2, _unitDataRef$current$3, _unitDataRef$current$4;
    const isColumnsFormValid = (_dataRef$current$vali = (_dataRef$current$vali2 = (_dataRef$current = dataRef.current).validate) === null || _dataRef$current$vali2 === void 0 ? void 0 : _dataRef$current$vali2.call(_dataRef$current)) !== null && _dataRef$current$vali !== void 0 ? _dataRef$current$vali : true;
    const isUnitSectionValid = (_unitDataRef$current$ = (_unitDataRef$current$2 = (_unitDataRef$current = unitDataRef.current).validate) === null || _unitDataRef$current$2 === void 0 ? void 0 : _unitDataRef$current$2.call(_unitDataRef$current)) !== null && _unitDataRef$current$ !== void 0 ? _unitDataRef$current$ : true;
    if (!isColumnsFormValid || !isUnitSectionValid) return;
    const data = dataRef.current;
    const units = (_store$homeDashboardS = (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.selectedPropertyDetails()) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.details) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.unitSetup) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.units) !== null && _store$homeDashboardS !== void 0 ? _store$homeDashboardS : [];
    const unitNameToId = Object.fromEntries(units.filter(u => u.id).map(u => [u.name, u.id]));
    const unitMappings = Object.entries((_unitDataRef$current$3 = unitDataRef.current.unitMappings) !== null && _unitDataRef$current$3 !== void 0 ? _unitDataRef$current$3 : {}).filter(_ref20 => {
      let _ref21 = _slicedToArray(_ref20, 2),
        csvName = _ref21[1];
      return csvName;
    }).map(_ref22 => {
      let _ref23 = _slicedToArray(_ref22, 2),
        unitName = _ref23[0],
        csvName = _ref23[1];
      return {
        unitId: unitNameToId[unitName] || unitName,
        identifiers: [csvName],
        isCommonArea: false
      };
    });
    const columnFields = COLUMN_FIELD_MAP.reduce((acc, _ref24) => {
      let field = _ref24.field;
      return _objectSpread(_objectSpread({}, acc), {}, {
        [field]: data[field] || ''
      });
    }, {});
    const resp = await store.allocations.postSubmeterBillingCsvMapAsync.run(_objectSpread(_objectSpread({
      propertyId,
      utilityId,
      propertyUtilityId,
      name: data.name
    }, columnFields), {}, {
      unitMappings
    }));
    if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) return;
    toast('success', {
      body: ['Mapping saved!']
    });
    onSave === null || onSave === void 0 || onSave(_objectSpread(_objectSpread({
      id: resp.response,
      name: data.name,
      propertyUtilityId
    }, columnFields), {}, {
      columnMappings: columnFields,
      unitMappings: (_unitDataRef$current$4 = unitDataRef.current.unitMappings) !== null && _unitDataRef$current$4 !== void 0 ? _unitDataRef$current$4 : {}
    }));
    handleClose();
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButtonInvert",
      size: "small",
      onClick: handleOpen
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, "Add mapping")),
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, "Map columns"),
    subTitle: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "light"
    }, "Map your CSV meter read columns to our system's field names."),
    rightButton: /*#__PURE__*/React.createElement(CreateSaveButton, {
      validityStore: validityStore,
      onClick: handleSave
    }),
    isOpen: isOpen,
    handleOpen: handleOpen,
    handleClose: handleClose
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MapColumnsFormContent, {
    key: formKey,
    dataRef: dataRef,
    onValidChange: handleFormValidChange
  }), /*#__PURE__*/React.createElement(MapUnitNamesSection, {
    dataRef: unitDataRef,
    onValidChange: handleUnitValidChange
  })));
};
export const MapColumnsEditModal = _ref25 => {
  var _mapping$unitMappings2;
  let mapping = _ref25.mapping,
    onSave = _ref25.onSave,
    propertyId = _ref25.propertyId,
    utilityId = _ref25.utilityId,
    propertyUtilityId = _ref25.propertyUtilityId;
  const store = useStore();
  const _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isOpen = _useState20[0],
    setIsOpen = _useState20[1];
  const _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    formKey = _useState22[0],
    setFormKey = _useState22[1];
  const dataRef = useRef({});
  const unitDataRef = useRef({});
  const validityStore = useLocalObservable(() => ({
    isFormValid: true,
    isUnitValid: true
  }));
  const handleFormValidChange = useCallback(valid => {
    validityStore.isFormValid = valid;
  }, [validityStore]);
  const handleUnitValidChange = useCallback(valid => {
    validityStore.isUnitValid = valid;
  }, [validityStore]);
  const handleOpen = () => {
    validityStore.isFormValid = true;
    validityStore.isUnitValid = true;
    setFormKey(k => k + 1);
    setIsOpen(true);
  };
  const handleClose = () => setIsOpen(false);
  const handleSave = async () => {
    var _dataRef$current$vali3, _dataRef$current$vali4, _dataRef$current2, _unitDataRef$current$5, _unitDataRef$current$6, _unitDataRef$current2, _store$homeDashboardS3, _store$homeDashboardS4, _unitDataRef$current$7, _unitDataRef$current$8;
    const isColumnsFormValid = (_dataRef$current$vali3 = (_dataRef$current$vali4 = (_dataRef$current2 = dataRef.current).validate) === null || _dataRef$current$vali4 === void 0 ? void 0 : _dataRef$current$vali4.call(_dataRef$current2)) !== null && _dataRef$current$vali3 !== void 0 ? _dataRef$current$vali3 : true;
    const isUnitSectionValid = (_unitDataRef$current$5 = (_unitDataRef$current$6 = (_unitDataRef$current2 = unitDataRef.current).validate) === null || _unitDataRef$current$6 === void 0 ? void 0 : _unitDataRef$current$6.call(_unitDataRef$current2)) !== null && _unitDataRef$current$5 !== void 0 ? _unitDataRef$current$5 : true;
    if (!isColumnsFormValid || !isUnitSectionValid) return;
    const data = dataRef.current;
    const units = (_store$homeDashboardS3 = (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.selectedPropertyDetails()) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.details) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.unitSetup) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.units) !== null && _store$homeDashboardS3 !== void 0 ? _store$homeDashboardS3 : [];
    const unitNameToId = Object.fromEntries(units.filter(u => u.id).map(u => [u.name, u.id]));
    const unitMappings = Object.entries((_unitDataRef$current$7 = unitDataRef.current.unitMappings) !== null && _unitDataRef$current$7 !== void 0 ? _unitDataRef$current$7 : {}).filter(_ref26 => {
      let _ref27 = _slicedToArray(_ref26, 2),
        csvName = _ref27[1];
      return csvName;
    }).map(_ref28 => {
      let _ref29 = _slicedToArray(_ref28, 2),
        unitName = _ref29[0],
        csvName = _ref29[1];
      return {
        unitId: unitNameToId[unitName] || unitName,
        identifiers: [csvName],
        isCommonArea: false
      };
    });
    const columnFields = COLUMN_FIELD_MAP.reduce((acc, _ref30) => {
      let field = _ref30.field;
      return _objectSpread(_objectSpread({}, acc), {}, {
        [field]: data[field] || ''
      });
    }, {});
    const resp = await store.allocations.putSubmeterBillingCsvMapAsync.run(_objectSpread(_objectSpread({
      id: mapping.id,
      propertyId,
      utilityId,
      propertyUtilityId,
      name: data.name
    }, columnFields), {}, {
      unitMappings
    }));
    if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) return;
    toast('success', {
      body: ['Mapping updated!']
    });
    onSave === null || onSave === void 0 || onSave(_objectSpread(_objectSpread(_objectSpread({}, mapping), {}, {
      name: data.name
    }, columnFields), {}, {
      columnMappings: columnFields,
      unitMappings: (_unitDataRef$current$8 = unitDataRef.current.unitMappings) !== null && _unitDataRef$current$8 !== void 0 ? _unitDataRef$current$8 : {}
    }));
    handleClose();
  };
  const initialUnitMappings = Array.isArray(mapping === null || mapping === void 0 ? void 0 : mapping.unitMappings) ? mapping.unitMappings.reduce((acc, _ref31) => {
    let unitId = _ref31.unitId,
      identifiers = _ref31.identifiers;
    return _objectSpread(_objectSpread({}, acc), {}, {
      [unitId]: (identifiers === null || identifiers === void 0 ? void 0 : identifiers[0]) || ''
    });
  }, {}) : (_mapping$unitMappings2 = mapping === null || mapping === void 0 ? void 0 : mapping.unitMappings) !== null && _mapping$unitMappings2 !== void 0 ? _mapping$unitMappings2 : {};
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(IconButton, {
      onClick: handleOpen
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    })),
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, "Edit mapping"),
    subTitle: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "light"
    }, "Update your CSV meter read column mappings."),
    rightButton: /*#__PURE__*/React.createElement(EditSaveButton, {
      validityStore: validityStore,
      onClick: handleSave
    }),
    isOpen: isOpen,
    handleOpen: handleOpen,
    handleClose: handleClose
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MapColumnsFormContent, {
    key: formKey,
    dataRef: dataRef,
    onValidChange: handleFormValidChange,
    initialValues: mapping
  }), /*#__PURE__*/React.createElement(MapUnitNamesSection, {
    dataRef: unitDataRef,
    onValidChange: handleUnitValidChange,
    initialUnitMappings: initialUnitMappings
  })));
};